"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomInt = void 0;
function randomInt(min, max) {
    if (max === void 0) { max = min; }
    min = Math.round(min + 0.4999999);
    max = Math.round(max - 0.5);
    if (min < 0 || min > max)
        return -1;
    return Math.round((max - min) * Math.random()) + min;
}
exports.randomInt = randomInt;
